<template>
  <footer>
    <div class="container">
      <vs-row>
        <vs-col w="6" sm="12">
          <h1 class="title">Sobre</h1>
          <p class="text">Desenvolvido manualmente usando adobe XD e Vue.js</p>
        </vs-col>
        <vs-col w="6" sm="12" class="lado-dir">
          <h1 class="title">Follow</h1>
          <div class="line-btn">
            <vs-button
              icon
              gradient
              href="https://github.com/WilkerLopes"
              blank
              data-cursor-hover
              data-cursor-mix-blend-mode="difference"
            >
              <ion-icon name="logo-github" class="color-3 x-large"></ion-icon>
            </vs-button>
            <vs-button
              icon
              gradient
              href="https://www.instagram.com/wilker.lop/"
              blank
              data-cursor-hover
              data-cursor-mix-blend-mode="difference"
            >
              <ion-icon
                name="logo-instagram"
                class="color-3 x-large"
              ></ion-icon>
            </vs-button>
            <vs-button
              icon
              gradient
              href="https://codepen.io/WilkerLopes/"
              blank
              data-cursor-hover
              data-cursor-mix-blend-mode="difference"
            >
              <ion-icon name="logo-codepen" class="color-3 x-large"></ion-icon>
            </vs-button>
          </div>
        </vs-col>
      </vs-row>
      <div
        class="text copyright"
        data-cursor-hover
        data-cursor-mix-blend-mode="difference"
      >
        © WilkerLopes 2021
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" src="./Footer.scss"></style>
